import { IApplicationState } from '../../types/redux';
import { getQuestionAuthorNameById } from '../questions';
import { getReviewAuthorNameById } from '../reviews';
import { TSetNewAnswerFormOpenPayload } from '../../actions/newAnswer/openFormActions';
import { getAnswerAuthorById } from '../answers/getAnswerAuthorById';

export const getAuthorNameById = (openId: TSetNewAnswerFormOpenPayload | null) => (state: IApplicationState) => {
  if (!openId) {
    return '';
  }

  const { id, type } = openId;

  switch (type) {
    case 'review':
      return getReviewAuthorNameById(id)(state);
    case 'question':
      return getQuestionAuthorNameById(id)(state);
    case 'answer':
      return getAnswerAuthorById(id)(state);
    default:
      return '';
  }
};
